export default "__VITE_ASSET__04d9386b__"